import React from 'react';
import ReceiptsCard, { ReceiptCardProps } from '../ReceiptsCard/ReceiptsCard';
import styles from './ReceiptsList.module.scss';
import Typography from '~/shared/components/Typography/Typography';
import { useTranslation } from '~/shared/utils/translation';

export interface ReceiptsListProps {
    receipts: Omit<ReceiptCardProps, 'className'>[];
    title?: string;
    description?: string;
    onReceiptClick?: (id: string) => void;
    className?: string;
    helpSection?: React.ReactNode;
    isLoading?: boolean;
    hasError?: boolean;
}

const ReceiptsList: React.FC<ReceiptsListProps> = ({
    receipts,
    title = 'MINE KVITTERINGER',
    description,
    onReceiptClick,
    className,
    helpSection,
    isLoading,
    hasError,
}) => {
    const { translate } = useTranslation();

    return (
        <div
            className={`${styles.container} ${className || ''}`}
            role="region"
            aria-labelledby="receipts-list-heading"
        >
            <Typography variant="title-XS" as="h2" id="receipts-list-heading">
                {title}
            </Typography>
            {description && (
                <Typography variant="paragraph-M" className={styles.description}>
                    {hasError
                        ? translate('loyalty.errorLoadingReceipts')
                        : isLoading
                          ? translate('loyalty.loadingReceipts')
                          : description}
                </Typography>
            )}

            <div className={styles.receiptsList}>
                {receipts.map((receipt) => (
                    <ReceiptsCard key={receipt.id} {...receipt} onClick={onReceiptClick} />
                ))}
            </div>

            {helpSection && <div className={styles.helpSection}>{helpSection}</div>}
        </div>
    );
};

export default ReceiptsList;
